"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.THIRTY_SECONDS = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _BaseReporter2 = _interopRequireDefault(require("./BaseReporter"));

var _ReporterActionTypes = _interopRequireDefault(require("./ReporterActionTypes"));

var _enviro = _interopRequireDefault(require("enviro"));

var _hubspot = _interopRequireDefault(require("hubspot"));

var THIRTY_SECONDS = 1000 * 30;
exports.THIRTY_SECONDS = THIRTY_SECONDS;

var formatVersion = function formatVersion(version) {
  if (!version) {
    return 'unknown';
  }

  if (version === 'static') {
    return 'dev';
  }

  return version.replace('static-', '');
};

var metricsEndpoint;

var getMetricsEndpoint = function getMetricsEndpoint() {
  if (!metricsEndpoint) {
    metricsEndpoint = "https://api.hubspot" + (_enviro.default.getShort() === 'prod' ? '' : 'qa') + ".com/cartographer/v1/in-app?hs_static_app=" + _hubspot.default.bender.currentProject + "&hs_static_app_version=" + formatVersion(_hubspot.default.bender.currentProjectVersion);
  }

  return metricsEndpoint;
};

var InAppReporter = /*#__PURE__*/function (_BaseReporter) {
  (0, _inherits2.default)(InAppReporter, _BaseReporter);

  function InAppReporter() {
    var _this;

    (0, _classCallCheck2.default)(this, InAppReporter);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(InAppReporter).call(this));
    _this.resolved = {};
    _this.actions = [];
    _this.previousAction = null;
    _this.flushQueueTimeout = undefined;
    window.addEventListener('unload', function () {
      _this.finish();
    }, false);
    return _this;
  }

  (0, _createClass2.default)(InAppReporter, [{
    key: "finish",
    value: function finish() {
      if (!this.actions.length) return;

      try {
        var sent = navigator.sendBeacon(getMetricsEndpoint(), JSON.stringify({
          datapoints: (0, _toConsumableArray2.default)(this.actions)
        }));

        if (sent) {
          this.actions = [];
        }
      } catch (e) {// Do nothing
      }
    }
  }, {
    key: "pushRoute",
    value: function pushRoute(routeInfo, status, duration) {
      if (this.previousAction) {
        this.actions.push({
          from: this.previousAction,
          to: routeInfo,
          duration: duration,
          status: status
        });
      }

      this.previousAction = routeInfo;
    } // TODO:
    // - handle "redirect imperative" case

  }, {
    key: "report",
    value: function report(action) {
      var _this2 = this;

      if (this.resolved[action.payload.entry.id] && action.type !== _ReporterActionTypes.default.CHECKS_CHANGED) {
        return;
      }

      switch (action.type) {
        case _ReporterActionTypes.default.ROUTE_TIMEOUT_EXPIRED:
        case _ReporterActionTypes.default.ROUTE_ABANDONED:
        case _ReporterActionTypes.default.ROUTE_FAILED:
          {
            var _action$payload = action.payload,
                entry = _action$payload.entry,
                routeSpec = _action$payload.routeSpec;
            var pathname = entry.pathname,
                checks = entry.checks,
                timestamp = entry.timestamp;
            var route = routeSpec.route,
                error = routeSpec.error;
            this.pushRoute({
              pathname: pathname,
              route: route,
              scenario: action.type === _ReporterActionTypes.default.ROUTE_FAILED && error ? error.join(',') : action.type
            }, 'failure', action.type === _ReporterActionTypes.default.ROUTE_FAILED && this.toDuration(checks, timestamp, error) || undefined);
            break;
          }

        case _ReporterActionTypes.default.ROUTE_SUCCEEDED:
          {
            var _action$payload2 = action.payload,
                _entry = _action$payload2.entry,
                _routeSpec = _action$payload2.routeSpec,
                extra = _action$payload2.extra;
            var _pathname = _entry.pathname,
                _checks = _entry.checks,
                _timestamp = _entry.timestamp;
            var _route = _routeSpec.route;
            var scenario = extra.scenario;
            var markers = _routeSpec.success[scenario] || '';
            this.pushRoute({
              pathname: _pathname,
              route: _route,
              scenario: scenario || markers.join(',')
            }, 'success', this.toDuration(_checks, _timestamp, markers));
            break;
          }

        default:
      }

      switch (action.type) {
        case _ReporterActionTypes.default.ROUTE_STARTED:
        case _ReporterActionTypes.default.CHECKS_CHANGED:
          break;

        default:
          {
            this.resolved[action.payload.entry.id] = true;
            clearTimeout(this.flushQueueTimeout);
            this.flushQueueTimeout = setTimeout(function () {
              _this2.finish();
            }, THIRTY_SECONDS);
          }
      }
    }
  }]);
  return InAppReporter;
}(_BaseReporter2.default);

exports.default = InAppReporter;